import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "22", x2: "11", y1: "2", y2: "13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polygon, { points: "22 2 15 22 11 13 2 9 22 2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Send";
const Send = memo(themed(Icon));
export {
  Send
};
//# sourceMappingURL=send.js.map
